export const appendLeadingZeros = (num: string, length = 2): string => num.padStart(length, '0');
